import { useTranslation } from 'react-i18next';
import { Button, Icons, iconSize } from '@munifocus/ui';
import { useSetWatching, useWatchState } from '../../lib/teamwork-api';

/**
 * Follow or stop following a file. Following sends the file's changes to the
 * officer's inbox (and by email or phone if they choose); it grants nothing,
 * and ends by itself if they lose access to the file.
 */
export function FollowFileButton({ fileId }: { fileId: string }) {
  const { t } = useTranslation();
  const state = useWatchState(fileId);
  const set = useSetWatching(fileId);
  const watching = state.data?.watching ?? false;
  const count = state.data?.watcherCount ?? 0;

  return (
    <Button
      size="small"
      variant={watching ? 'contained' : 'outlined'}
      aria-pressed={watching}
      disabled={state.isLoading || set.isPending}
      startIcon={
        watching ? <Icons.BellRing size={iconSize.sm} /> : <Icons.Bell size={iconSize.sm} />
      }
      onClick={() => set.mutate(!watching)}
      title={t('gov.teamwork.follow.hint')}
    >
      {watching ? t('gov.teamwork.follow.following') : t('gov.teamwork.follow.follow')}
      {count > 0 ? ` · ${t('gov.teamwork.follow.count', { count })}` : ''}
    </Button>
  );
}
